<div class="item user-block" *ngIf="userBlockIsVisible()">
    <!-- User picture-->
    <div class="user-block-picture" [routerLink]="'/home'">
        <div class="user-block-status">
            <img class="img-thumbnail rounded-circle" *ngIf="user" [src]="getUserImage()" alt="Avatar" />
            <div class="circle bg-success circle-lg"></div>
        </div>
    </div>
    <!-- Name and Job-->
    <div class="user-block-info">
        <span class="user-block-name">{{ 'sidebar.WELCOME' | translate }} {{user?.name}}</span>
        <span class="user-block-role" *ngIf="settings.user?.jobTitle" >{{user?.jobTitle}}</span>
    </div>
</div>
